<template>
  <div @click="click" class="app-dropdown-menu-item">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppDropdownMenuItem',

  computed: {
    dropdownMenu() {
      return this.findComponentInParent('AppDropdownMenu')
    },
  },

  methods: {
    click(event) {
      this.dropdownMenu.close()
      this.$emit('click', event)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/settings.scss';

.app-dropdown-menu-item {
  padding: $defaultPadding;
  display: flex;
  align-items: center;
  line-height: 100%;

  > * {
    margin-left: 1rem;

    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
